var exports = {
  "j": "x04b3a21e--acd683--overflow",
  "A": "x04b3a21e--acd683--item",
};

module.exports = exports;
